export default __webpack_public_path__ + "static/media/bbcoLogo.d5602f98.png";